import {
  SET_USER_URN
} from './types'

export const setUserUrn = (userUrn: string): { type: typeof SET_USER_URN, userUrn: string } => ({
  type: SET_USER_URN,
  userUrn
})
